import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';
import { IntegrationScandlinesData } from './Data';

export type IntegrationScandlinesState = BaseIntegrationState;

export class IntegrationScandlinesModel extends BaseIntegration<IntegrationScandlinesData, IntegrationScandlinesState> {
  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/custom/scandlines/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Ani Mikova';
  }
}
